<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0px !important;
  padding: 0px !important;
  user-select: none;
}
#app {
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #f2f3f5;
}
</style>
<style lang="scss" scoped></style>
